import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, BotIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-82" data-mp="sa9szg4tfxxp">
      <div className="h-1 w-full bg-electric shadow-[0_0_16px_rgba(0,207,255,0.7)]" aria-hidden="true" data-id="element-83" data-mp="ncq1hej3xont" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-84" data-mp="3d21v45faeyrf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-electric/60 bg-surface px-4 py-2 font-display text-sm font-bold uppercase tracking-[.14em] text-foreground shadow-glow" data-id="element-85" data-mp="382p91mw8pvpw">
          <BotIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-86" data-mp="3e9625rf943h1" /> {productBrand}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-4xl" data-id="element-87" data-mp="30hhnphhj52ww">
          <img src={productImage} alt="Industrial Automation & PLC Systems Professional Edition: six volumes covering automation fundamentals, PLC systems and architecture, PLC logic, sensors and industrial I/O, HMI/SCADA and communication, troubleshooting and maintenance, plus five bonus resources" className="mx-auto w-full drop-shadow-[0_24px_48px_rgba(0,207,255,0.25)]" data-id="element-88" data-mp="2qi0nvgoylj8u" />
        </motion.div>

        <div className="mt-8" data-id="element-89" data-mp="s3umzlkswo5c">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-90" data-mp="nb1kz5gpvtwy">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-sm font-semibold text-foreground" data-id="element-91" data-mp="i9vrh5f8g2md">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-electric/40 bg-surface px-3 py-2" data-id="element-92" data-mp="1b0duy7jvc60b">
              <Icon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-93" data-mp="112px38qyuidx" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}